import React from 'react';
import useIsLargeScreen from '@src/hooks/useIsLargeScreen';
import { TSprungOverlayLocations } from '@src/utils/wysiwyg_editor/contentItemHandleLocations';
import { DISPLAY_STATES } from './BuilderImage';
import AddImageButton from './image/AddImageButton';
import DropImageButton from './image/DropImageButton';

interface Props {
  currentDisplayState: string;
  frameDomSpringValues: TSprungOverlayLocations;
  stackOrder: number;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

function ImageCallToAction({
  currentDisplayState,
  frameDomSpringValues,
  stackOrder,
  onMouseEnter,
  onMouseLeave
}: Props): React.ReactElement {
  const isLarge = useIsLargeScreen();

  if (isLarge) {
    return (
      <DropImageButton
        location={frameDomSpringValues}
        showBorder={currentDisplayState === DISPLAY_STATES.render}
        stackOrder={stackOrder}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    );
  }

  return (
    <AddImageButton
      location={frameDomSpringValues}
      showBorder={currentDisplayState === DISPLAY_STATES.render}
      clickedOnceAlready={
        ![DISPLAY_STATES.render, DISPLAY_STATES.hover].includes(
          currentDisplayState
        )
      }
      stackOrder={stackOrder}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
}

export default ImageCallToAction;
